import useMutation from '@space-shell/common/hooks/useMutation'
import type {
  NotificationCount,
  NotificationList
} from '@space-shell/common/services/notifications'
import { CONTEXT, NotificationsService } from '@space-shell/common/services/notifications'
import { NotificationsEndpoints } from '@space-shell/common/services/notifications'
import { useQueryClient } from '@tanstack/react-query'
import type { InfiniteData } from '@tanstack/react-query'

export const useReadAllMutation = () => {
  const queryClient = useQueryClient()

  const updateNotificationListQueryData = () => {
    queryClient.setQueryData<InfiniteData<NotificationList>>(
      [NotificationsEndpoints.notifications()],
      (oldData) => {
        if (!oldData) {
          return oldData
        }

        const pages = oldData?.pages?.map((page) => {
          const notifications = page?.notifications?.map((notification) => ({
            ...notification,
            read: true
          }))

          return { ...page, notifications }
        })

        return { ...oldData, pages }
      }
    )
  }

  const updateCountQueryData = () => {
    queryClient.setQueryData<NotificationCount>([NotificationsEndpoints.count()], (oldData) => {
      if (!oldData) {
        return oldData
      }

      return { ...oldData, unread: 0 }
    })
  }

  return useMutation<void, void>(
    () =>
      NotificationsService.patchReadAll({
        markRead: true,
        context: CONTEXT.CLUB
      }),
    {
      onSuccess: () => {
        updateNotificationListQueryData()
        updateCountQueryData()
      }
    }
  )
}
